// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PhotoPreviewController from "./photo_preview_controller"
application.register("photo-preview", PhotoPreviewController)

import VariantPricingController from "./variant_pricing_controller"
application.register("variant-pricing", VariantPricingController)

import FieldTypeController from "./field_type_controller"
application.register("field-type", FieldTypeController)

import ProductViewController from "./product_view_controller"
application.register("product-view", ProductViewController)

import SupplyItemPricingController from "./supply_item_pricing_controller"
application.register("supply-item-pricing", SupplyItemPricingController)

import SupplyCostComponentsController from "./supply_cost_components_controller"
application.register("supply-cost-components", SupplyCostComponentsController)

import SupplySummaryController from "./supply_summary_controller"
application.register("supply-summary", SupplySummaryController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FilterDropdownController from "./filter_dropdown_controller"
application.register("filter-dropdown", FilterDropdownController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import OrderItemController from "./order_item_controller"
application.register("order-item", OrderItemController)

import OrderSummaryController from "./order_summary_controller"
application.register("order-summary", OrderSummaryController)

import CurrencyRateController from "./currency_rate_controller"
application.register("currency-rate", CurrencyRateController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)
import DarkModeController from "./dark_mode_controller"
application.register("dark-mode", DarkModeController)

import SupplyDuplicatesController from "./supply_duplicates_controller"
application.register("supply-duplicates", SupplyDuplicatesController)

import SortablePhotosController from "./sortable_photos_controller"
application.register("sortable-photos", SortablePhotosController)

import AttachmentRemoverController from "./attachment_remover_controller"
application.register("attachment-remover", AttachmentRemoverController)

import VariantTabsController from "./variant_tabs_controller"
application.register("variant-tabs", VariantTabsController)

import VariantDescriptionController from "./variant_description_controller"
application.register("variant-description", VariantDescriptionController)

import ProductFormValidatorController from "./product_form_validator_controller"
application.register("product-form-validator", ProductFormValidatorController)

import ProductOptionsController from "./product_options_controller"
application.register("product-options", ProductOptionsController)

import PrimaryCategoryController from "./primary_category_controller"
application.register("primary-category", PrimaryCategoryController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AvailabilityNoticeController from "./availability_notice_controller"
application.register("availability-notice", AvailabilityNoticeController)

import VariantAvailabilityController from "./variant_availability_controller"
application.register("variant-availability", VariantAvailabilityController)

import FilterPersistenceController from "./filter_persistence_controller"
application.register("filter-persistence", FilterPersistenceController)

import SortPersistenceController from "./sort_persistence_controller"
application.register("sort-persistence", SortPersistenceController)

import SlideoutController from "./slideout_controller"
application.register("slideout", SlideoutController)

import FieldConfigController from "./field_config_controller"
application.register("field-config", FieldConfigController)

import AiSidebarController from "./ai_sidebar_controller"
application.register("ai-sidebar", AiSidebarController)

import CollapsibleSidebarController from "./collapsible_sidebar_controller"
application.register("collapsible-sidebar", CollapsibleSidebarController)

import BuyerSelectorController from "./buyer_selector_controller"
application.register("buyer-selector", BuyerSelectorController)

import TableExpandController from "./table_expand_controller"
application.register("table-expand", TableExpandController)

import OrdersChartController from "./orders_chart_controller"
application.register("orders-chart", OrdersChartController)

import MediaPickerController from "./media_picker_controller"
application.register("media-picker", MediaPickerController)

import ProductStockModeController from "./product_stock_mode_controller"
application.register("product-stock-mode", ProductStockModeController)

import PhoneInputController from "./phone_input_controller"
application.register("phone-input", PhoneInputController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import VariantPhotoViewerController from "./variant_photo_viewer_controller"
application.register("variant-photo-viewer", VariantPhotoViewerController)

import MediaPreviewController from "./media_preview_controller"
import BlockArrayController from "./block_array_controller"
application.register("block-array", BlockArrayController)

import BuilderMediaFieldController from "./builder_media_field_controller"
application.register("builder-media-field", BuilderMediaFieldController)
import ProductGalleryController from "./product_gallery_controller"
application.register("product-gallery", ProductGalleryController)
import ProductVariantSwitcherController from "./product_variant_switcher_controller"
application.register("product-variant-switcher", ProductVariantSwitcherController)
application.register("media-preview", MediaPreviewController)

import BuilderController from "./builder_controller"
application.register("builder", BuilderController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import ColorFieldController from "./color_field_controller"
application.register("color-field", ColorFieldController)

import ThemeSettingsController from "./theme_settings_controller"
application.register("theme-settings", ThemeSettingsController)

import DraftPreviewController from "./draft_preview_controller"
application.register("draft-preview", DraftPreviewController)

import CatalogFacetsController from "./catalog_facets_controller"
application.register("catalog-facets", CatalogFacetsController)

import BlockFormController from "./block_form_controller"
application.register("block-form", BlockFormController)

import CartDrawerController from "./cart_drawer_controller"
application.register("cart-drawer", CartDrawerController)

import FilterPresetController from "./filter_preset_controller"
application.register("filter-preset", FilterPresetController)
